import { createClient } from '@supabase/supabase-js';

// ─── SUPABASE CLIENT ──────────────────────────────────────────────────────────
// CRA uses process.env.REACT_APP_* — Vercel buildCommand is react-scripts build
const SUPA_URL  = process.env.REACT_APP_SUPABASE_URL  || '';
const SUPA_ANON = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

export const supabase = SUPA_URL && SUPA_ANON
  ? createClient(SUPA_URL, SUPA_ANON, {
      auth: {
        flowType: 'pkce',
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
        // Explicit storage key so getCachedSession() reads the right key
        storageKey: `sb-${(SUPA_URL.match(/https:\/\/([^.]+)/)?.[1] || 'mylo')}-auth-token`,
      },
    })
  : null;

// ── Read cached Supabase session from localStorage synchronously ──────────────
export function getCachedSession() {
  if (!supabase) return null;
  try {
    const projectRef = SUPA_URL.match(/https:\/\/([^.]+)/)?.[1] || '';
    const key = `sb-${projectRef}-auth-token`;
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const session = JSON.parse(raw);
    if (session?.expires_at) {
      const expiresAt = typeof session.expires_at === 'number'
        ? session.expires_at * 1000
        : new Date(session.expires_at).getTime();
      if (Date.now() > expiresAt - 60000) return null;
    }
    return session?.user || null;
  } catch {
    return null;
  }
}
